import LockedQuantityDropdown from './LockedQuantityDropdown';

export default LockedQuantityDropdown;
